import { AxiosResponse } from 'axios';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ResponseBase } from 'src/app/models/response-base';
import { GroupResponse } from '../../models/group/group-response.model';
import { api } from '../../services/api';
import { GROUP_LIST, PRODUCTS_GROUP } from '../contants';
import { getGroupsError, getGroupsSuccess, getProductsOfGroupError, getProductsOfGroupSuccess } from './actions';

type fetchGroupsPayload = { assignorGuid: string };
type fetchGroupsParams = { payload: fetchGroupsPayload, type: string };

type fetchProductsOfGroupsPayload = { groupId: number, assignorGuid: string }
type fetchProductsOfGroupsParams = { payload: fetchProductsOfGroupsPayload, type: string };

export function* watchFetchGroups() {
  yield takeEvery(GROUP_LIST, fetchGroups);
}

const fetchGroupsAsync = async (assignorGuid: string) =>
  await api.get(`group/assignors/${assignorGuid}`)
    .then((response: any) => response)
    .catch((error: any) => error);


function* fetchGroups({ payload }: fetchGroupsParams) {
  try {
    const { assignorGuid } = payload;
    const response: AxiosResponse<ResponseBase<GroupResponse[]>> = yield call(fetchGroupsAsync, assignorGuid);

    if (response?.data?.status == 1) {
      yield put(getGroupsSuccess(response?.data?.result));
    } else {
      yield put(getGroupsError(response?.data?.message));
    }
  } catch (error) {
    yield put(getGroupsError(error));
  }
}

export function* watchFetchProductsOfGroup() {
  yield takeEvery(PRODUCTS_GROUP, fetchProductsOfGroup);
}

const fetchProductsOfGroupAsync = async (groupId: number, assignorGuid: string) =>
  await api.get(`group/productsOfGroup/${groupId}/assignors/${assignorGuid}`)
    .then((response: any) => response)
    .catch((error: any) => error);


function* fetchProductsOfGroup({ payload }: fetchProductsOfGroupsParams) {
  try {
    const { groupId, assignorGuid } = payload;
    const response: AxiosResponse<ResponseBase<number[]>> = yield call(fetchProductsOfGroupAsync, groupId, assignorGuid);

    if (response?.data?.status == 1) {
      yield put(getProductsOfGroupSuccess(groupId, response?.data?.result));
    } else {
      yield put(getProductsOfGroupError(response?.data?.message));
    }
  } catch (error) {
    yield put(getProductsOfGroupError(error));
  }
}


export default function* rootSaga() {
  yield all([
    fork(watchFetchGroups),
    fork(watchFetchProductsOfGroup)
  ]);
}
